// extracted by mini-css-extract-plugin
export var active = "NavigationItem-module--active--522a6";
export var container = "NavigationItem-module--container--49242";
export var dark = "NavigationItem-module--dark--30a42";
export var light = "NavigationItem-module--light--0a8c2";
export var link = "NavigationItem-module--link--87865";
export var svg = "NavigationItem-module--svg--c9e57";